// extracted by mini-css-extract-plugin
export default {"thoughts":"testimonial_thoughts__iB0gr","errorText":"testimonial_errorText__Lvb73"};